export enum TipoLancamentoEnum {
    CREDITO = 'CREDITO',
    DEBITO = 'DEBITO'
}
